import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";

const inputCls = "w-full rounded-xl border border-neutral-700 bg-black px-4 py-3 text-sm text-stone-100 outline-none focus:border-white";

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => setEmail(r.data.email)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("Passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/accept-invite", { token, password: pw.a });
      toast.success("Password set. Please log in.");
      nav("/admin/login");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="mx-auto max-w-md px-4 py-24" data-testid="accept-invite-page">
      <Logo className="mx-auto h-20" />
      <h1 className="mt-8 text-center font-display text-3xl uppercase text-chrome">Set Your Password</h1>
      {error ? <p className="mt-6 text-center text-red-400" data-testid="invite-error">{error}</p> : (
        <form onSubmit={submit} className="glass mt-8 space-y-3 rounded-3xl p-6">
          <p className="text-sm text-neutral-400">Invitation for <span className="text-white" data-testid="invite-email">{email || "…"}</span></p>
          <input type="password" required minLength={8} placeholder="New password (min 8)" value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} data-testid="invite-password" className={inputCls} />
          <input type="password" required placeholder="Confirm password" value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} data-testid="invite-confirm" className={inputCls} />
          <button type="submit" disabled={busy || !email} data-testid="invite-submit" className="btn-gold w-full rounded-full py-3.5 font-display text-lg uppercase disabled:opacity-60">
            {busy ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : "Activate Access"}
          </button>
        </form>
      )}
    </div>
  );
}
